<div class="card shadow-sm">
  <div class="card-header">
    <h3 class="card-title">Categories</h3>
  </div>
  <div class="card-body">
    @if (categoriesOptions.length > 0) {
      <form [formGroup]="form">
        <div class="row g-3">
          @if (alertInfo.show) {
            <ngb-alert [type]="alertInfo.type" (closed)="alertInfo.show = false">
              <div [innerHTML]="alertInfo.message"></div>
            </ngb-alert>
          }
          <div class="col-12 mt-2">
            <checkbox-field [options]="categoriesOptions" [selectedValues]="selectedCategoryIds"
              (selectedValuesChange)="onCategoriesChange($event)" [readonly]="readonlyRegulationsCategories">
            </checkbox-field>
          </div>
        </div>
      </form>
    }
  </div>
</div>